<template>
  <v-menu
    ref="menuDate"
    :close-on-content-click="false"
    v-model="menuDate"
    :return-value.sync="date"
    max-width="280px"
    min-width="280px"
    class="pr-4 mt-2"
    transition="scale-transition"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-bind="$attrs"
        v-on="on"
        v-model="date"
        :label="label"
        readonly
        class="date-input"
        :disabled="disabled"
        :clearable="false"
      >
        <template v-if="clearable" #append>
          <v-icon size="20" @click="clear">
            mdi-close-circle-outline
          </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      color="primary lighten-1"
      :locale="$i18n.locale"
      :max="max"
      width="280"
      @input="save"
    />
  </v-menu>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default() {
        return this.$t('common.fields.rentDate');
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    noMax: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    menuDate: false,
    date: '',
  }),
  computed: {
    max() {
      if (this.noMax) return null;
      return new Date().toISOString().substr(0, 10);
    },
  },
  watch: {
    value(val) {
      this.date = val;
    },
  },
  methods: {
    clear() {
      this.$emit('change', '');
      this.date = '';
    },
    save() {
      this.$refs.menuDate.save(this.date);
      this.$emit('change', this.date);
    },
  },
  created() {
    if (this.value) this.date = this.value;
  },
  mounted() {
    if (this.autofocus) {
      this.$nextTick(() => {
        this.menuDate = true;
      });
    }
  },
};
</script>

<style>
.date-input {
  min-width: 100px;
}
.date-input .v-input {
  padding-left: 0 !important;
}
</style>
